// extracted by mini-css-extract-plugin
module.exports = {"layout":"_11D3raTowBsm7KQzn4kdxS","userCard":"_3MB_ktATp-cLZgnQrz3AbJ","activty":"_3a0oq1vMvfkY6YkVXyk7yY","backgroundCard":"_2exoKE-abhIinue1Nd90nF"};